import React from "react";
import styled from "styled-components";
import { keyframes } from "styled-components";

//Logo List 
import champneys from "../../logos/champneys.jpg"
import cybert from "../../logos/cybert.png"
import caplor from "../../logos/caplor.png"
import ambrey from "../../logos/ambrey.png"
import cisco from "../../logos/cisco.png"
import base3 from "../../logos/base3.png"
import cola from "../../logos/cola.png"
import cq from "../../logos/cq.png"
import sony from "../../logos/Sony.jpg";
import ultra from "../../logos/Ultra.png";
import serbus from "../../logos/serbus.png";
import dhl from "../../logos/dhl.png";
import dmlab from "../../logos/dmlab.png";
import dynamics from "../../logos/dynamics.png";
import ee from "../../logos/ee.png";
import pfizer from "../../logos/pfizer.png";
import microsoft from "../../logos/Microsoft.png";
import sequani from "../../logos/sequani.png";
import westfieldsfc from "../../logos/westfieldsfc.png";
import image00 from "../../logos/00.jpg";
import image01 from "../../logos/01.jpg";
import image02 from "../../logos/02.jpg";
import image03 from "../../logos/03.jpg";
import image04 from "../../logos/04.jpg";
import image05 from "../../logos/05.jpg";
import image06 from "../../logos/06.jpg";
import image07 from "../../logos/07.jpg";
import image08 from "../../logos/08.jpg";
import image09 from "../../logos/09.jpg";
import image10 from "../../logos/10.jpg";
import image11 from "../../logos/11.jpg";
import image12 from "../../logos/12.jpg";
import image13 from "../../logos/13.jpg";
import image14 from "../../logos/14.jpg";
import image15 from "../../logos/15.jpg";
import image16 from "../../logos/16.jpg";
import image17 from "../../logos/17.jpg";
import image18 from "../../logos/18.jpg";
import image19 from "../../logos/19.jpg";
import image20 from "../../logos/20.jpg";
import image21 from "../../logos/21.jpg";
import image22 from "../../logos/22.jpg";
import image23 from "../../logos/23.jpg";
import image24 from "../../logos/24.jpg";
import image25 from "../../logos/25.jpg";
import image26 from "../../logos/26.jpg";
import image27 from "../../logos/27.jpg";
import image28 from "../../logos/28.jpg";
import image29 from "../../logos/29.jpg";
import image30 from "../../logos/30.jpg";
import image31 from "../../logos/31.jpg";
import image32 from "../../logos/32.jpg";
import image33 from "../../logos/33.jpg";
import image34 from "../../logos/34.jpg";
import image35 from "../../logos/35.jpg";
import image36 from "../../logos/36.jpg";
import image37 from "../../logos/37.jpg";
import image38 from "../../logos/38.jpg";
import image39 from "../../logos/39.jpg";
import image40 from "../../logos/40.jpg";
import image41 from "../../logos/41.jpg";
import image42 from "../../logos/42.jpg";
import image43 from "../../logos/43.jpg";
import image44 from "../../logos/44.jpg";
import image45 from "../../logos/45.jpg";
import image46 from "../../logos/46.jpg";
import image47 from "../../logos/47.jpg";
import image48 from "../../logos/48.jpg";
import image49 from "../../logos/49.jpg";
import image50 from "../../logos/50.jpg";
import image51 from "../../logos/51.jpg";
import image52 from "../../logos/52.jpg";
import image53 from "../../logos/53.jpg";
import image54 from "../../logos/54.jpg";
import image55 from "../../logos/55.jpg";
import image56 from "../../logos/56.jpg";
import image57 from "../../logos/57.jpg";
import image58 from "../../logos/58.jpg";
import image59 from "../../logos/59.jpg";
import image60 from "../../logos/60.jpg";



// Array of logo image paths or URLs
const logoData = [
  { src: ambrey, width: 270, height: 150 },
  { src: base3, width: 200, height: 150 },
  { src: champneys, width: 350, height: 150 },
  { src: cisco, width: 150, height: 150 },
  { src: microsoft, width: 350, height: 150 },
  { src: cola, width: 150, height: 150 },
  { src: cq, width: 250, height: 150 },
  { src: cybert, width: 150, height: 150 },
  { src: sony, width: 250, height: 150 },
  { src: ultra, width: 350, height: 150 },
  { src: serbus, width: 350, height: 150 },
  { src: dhl, width: 350, height: 150 },
  { src: dmlab, width: 350, height: 150 },
  { src: caplor, width: 350, height: 150 },
  { src: dynamics, width: 270, height: 150 },
  { src: ee, width: 150, height: 150 },
  { src: pfizer, width: 200, height: 150 },
  { src: sequani, width: 200, height: 150 },
  { src: westfieldsfc, width: 350, height: 150 },
  { src: ambrey, width: 270, height: 150 },
  { src: base3, width: 200, height: 150 },
  { src: champneys, width: 350, height: 150 },
  { src: cisco, width: 150, height: 150 },
  { src: microsoft, width: 350, height: 150 },
  { src: cola, width: 150, height: 150 },
  { src: cq, width: 250, height: 150 },
  { src: cybert, width: 150, height: 150 },
  { src: sony, width: 250, height: 150 },
  { src: ultra, width: 350, height: 150 },
  { src: serbus, width: 350, height: 150 },
  { src: dhl, width: 350, height: 150 },
  { src: dmlab, width: 350, height: 150 },
  { src: caplor, width: 350, height: 150 },
  { src: dynamics, width: 270, height: 150 },
  { src: ee, width: 150, height: 150 },
  { src: pfizer, width: 200, height: 150 },
  { src: sequani, width: 200, height: 150 },
  { src: westfieldsfc, width: 350, height: 150 },
  { src: image00, width: 350, height: 150 },
{ src: image01, width: 350, height: 150 },
{ src: image02, width: 350, height: 150 },
{ src: image03, width: 350, height: 150 },
{ src: image04, width: 350, height: 150 },
{ src: image05, width: 350, height: 150 },
{ src: image06, width: 350, height: 150 },
{ src: image07, width: 350, height: 150 },
{ src: image08, width: 350, height: 150 },
{ src: image09, width: 350, height: 150 },
{ src: image10, width: 350, height: 150 },
{ src: image11, width: 350, height: 150 },
{ src: image12, width: 350, height: 150 },
{ src: image13, width: 350, height: 150 },
{ src: image14, width: 350, height: 150 },
{ src: image15, width: 350, height: 150 },
{ src: image16, width: 350, height: 150 },
{ src: image17, width: 350, height: 150 },
{ src: image18, width: 350, height: 150 },
{ src: image19, width: 350, height: 150 },
{ src: image20, width: 350, height: 150 },
{ src: image21, width: 350, height: 150 },
{ src: image22, width: 350, height: 150 },
{ src: image23, width: 350, height: 150 },
{ src: image24, width: 350, height: 150 },
{ src: image25, width: 350, height: 150 },
{ src: image26, width: 350, height: 150 },
{ src: image27, width: 350, height: 150 },
{ src: image28, width: 350, height: 150 },
{ src: image29, width: 350, height: 150 },
{ src: image30, width: 350, height: 150 },
{ src: image31, width: 350, height: 150 },
{ src: image32, width: 350, height: 150 },
{ src: image33, width: 350, height: 150 },
{ src: image34, width: 350, height: 150 },
{ src: image35, width: 350, height: 150 },
{ src: image36, width: 350, height: 150 },
{ src: image37, width: 350, height: 150 },
{ src: image38, width: 350, height: 150 },
{ src: image39, width: 350, height: 150 },
{ src: image40, width: 350, height: 150 },
{ src: image41, width: 350, height: 150 },
{ src: image42, width: 350, height: 150 },
{ src: image43, width: 350, height: 150 },
{ src: image44, width: 350, height: 150 },
{ src: image45, width: 350, height: 150 },
{ src: image46, width: 350, height: 150 },
{ src: image47, width: 350, height: 150 },
{ src: image48, width: 350, height: 150 },
{ src: image49, width: 350, height: 150 },
{ src: image50, width: 350, height: 150 },
{ src: image51, width: 350, height: 150 },
{ src: image52, width: 350, height: 150 },
{ src: image53, width: 350, height: 150 },
{ src: image54, width: 350, height: 150 },
{ src: image55, width: 350, height: 150 },
{ src: image56, width: 350, height: 150 },
{ src: image57, width: 350, height: 150 },
{ src: image58, width: 350, height: 150 },
{ src: image59, width: 350, height: 150 },
{ src: image60, width: 350, height: 150 },
];

const scroll = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(-200%);
  }
`;

const LogoGroupWrapper = styled.div`
${(props) =>
  props.isFilterActive &&
  `
    background-color: rgba(, 0, 0, 0); /* Adjust the opacity and color as needed */
    filter: grayscale(100%); /* Apply grayscale filter to make it grey */
  `}
  
  padding: 20px;
  display: flex;
  overflow: hidden;
  width: auto;
`;

const LogoScroller = styled.div`
  display: flex;
  justify-content: space-between;
  animation: ${scroll} 140s linear infinite;
`;

const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  margin: 0 50px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

const LogoGroupScroll = ({ isFilterActive }) => {
  // Duplicate the logos to create a seamless loop
  const duplicatedLogos = [...logoData, ...logoData, ...logoData,];

  return (
    <LogoGroupWrapper isFilterActive={isFilterActive}>
      <LogoScroller>
        {duplicatedLogos.map((logo, index) => (
          <StyledLogoImage
            key={index}
            src={logo.src}
            alt={`Logo ${index + 1}`}
            width={logo.width}
            height={logo.height}
          />
        ))}
      </LogoScroller>
    </LogoGroupWrapper>
  );
};

const StyledLogoImage = styled(LogoImage)`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default LogoGroupScroll;
